"use strict";
/*
 * Ahoy.js
 * Simple, powerful JavaScript analytics
 * https://github.com/ankane/ahoy.js
 * v0.1.0
 * MIT License
 */
// Modified to use Higgs RPC backend and remove jQuery usage
/*jslint browser: true, indent: 2, plusplus: true, vars: true */
(function (window) {
    "use strict";
    var ahoy = window.ahoy || window.Ahoy || {};
    var visitId, visitorId, track;
    var visitTtl = 4 * 60; // 4 hours
    var visitorTtl = 2 * 365 * 24 * 60; // 2 years
    var isReady = false;
    var queue = [];
    var canStringify = typeof JSON !== "undefined" && typeof JSON.stringify !== "undefined";
    var eventQueue = [];
    var page = ahoy.page || window.location.pathname;
    var visitsUrl = ahoy.visitsUrl || "/dziendobry/visits";
    var eventsUrl = ahoy.eventsUrl || "/api/v1/sites/rpc?TrackEventsRequest";
    // cookies
    // http://www.quirksmode.org/js/cookies.html
    function setCookie(name, value, ttl) {
        var expires = "";
        var cookieDomain = "";
        if (ttl) {
            var date = new Date();
            date.setTime(date.getTime() + ttl * 60 * 1000);
            expires = "; expires=" + date.toUTCString();
        }
        if (ahoy.domain) {
            cookieDomain = "; domain=" + ahoy.domain;
        }
        // Modification (SameSite/ Secure)
        document.cookie =
            name +
                "=" +
                escape(value) +
                expires +
                cookieDomain +
                "; path=/; SameSite=None; Secure;";
    }
    function getCookie(name) {
        var i, c;
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (i = 0; i < ca.length; i++) {
            c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return unescape(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    }
    function destroyCookie(name) {
        setCookie(name, "", -1);
    }
    function log(message) {
        if (getCookie("ahoy_debug")) {
            window.console.log(message);
        }
    }
    function setReady() {
        var callback;
        while ((callback = queue.shift())) {
            callback();
        }
        isReady = true;
    }
    function ready(callback) {
        if (isReady) {
            callback();
        }
        else {
            queue.push(callback);
        }
    }
    // http://stackoverflow.com/a/2117523/1177228
    function generateId() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0, v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    function saveEventQueue() {
        // TODO add stringify method for IE 7 and under
        if (canStringify) {
            setCookie("ahoy_events", JSON.stringify(eventQueue), 1);
        }
    }
    function trackEvent(event) {
        ready(function () {
            // ensure JSON is defined
            if (canStringify) {
                fetch(eventsUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                    },
                    body: JSON.stringify({
                        id: "",
                        method: "TrackEventsRequest",
                        params: [event],
                    }),
                })
                    .then(() => {
                    // remove from queue
                    for (let i = 0; i < eventQueue.length; i++) {
                        if (eventQueue[i].id == event.id) {
                            eventQueue.splice(i, 1);
                            break;
                        }
                    }
                    saveEventQueue();
                })
                    .catch((error) => console.error(error));
            }
        });
    }
    function eventProperties(target) {
        const parentSection = target.closest("[data-section]");
        return {
            tag: target.tagName.toLowerCase(),
            id: target.getAttribute("id"),
            class: target.getAttribute("class"),
            page: page,
            section: parentSection
                ? parentSection.getAttribute("data-section")
                : null,
        };
    }
    // main
    visitId = getCookie("ahoy_visit");
    visitorId = getCookie("ahoy_visitor");
    track = getCookie("ahoy_track");
    let initialized = false;
    ahoy.init = function () {
        initialized = true;
        if (visitId && visitorId && !track) {
            // TODO keep visit alive?
            log("Active visit");
            setReady();
        }
        else {
            if (track) {
                destroyCookie("ahoy_track");
            }
            if (!visitId) {
                visitId = generateId();
                setCookie("ahoy_visit", visitId, visitTtl);
            }
            // make sure cookies are enabled
            if (getCookie("ahoy_visit")) {
                log("Visit started");
                if (!visitorId) {
                    visitorId = generateId();
                    setCookie("ahoy_visitor", visitorId, visitorTtl);
                }
                var data = {
                    visit_token: visitId,
                    visitor_token: visitorId,
                    platform: ahoy.platform || "Web",
                    landing_page: window.location.href,
                    screen_width: window.screen.width,
                    screen_height: window.screen.height,
                };
                // referrer
                if (document.referrer.length > 0) {
                    data.referrer = document.referrer;
                }
                log(data);
                fetch(visitsUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                    },
                    body: JSON.stringify(data),
                })
                    .then(() => {
                    setReady();
                })
                    .catch((error) => console.error(error));
            }
            else {
                log("Cookies disabled");
                setReady();
            }
        }
        // push events from queue
        try {
            eventQueue = JSON.parse(getCookie("ahoy_events") || "[]");
        }
        catch (e) {
            // do nothing
        }
        for (var i = 0; i < eventQueue.length; i++) {
            trackEvent(eventQueue[i]);
        }
    };
    ahoy.getVisitId = ahoy.getVisitToken = function () {
        return visitId;
    };
    ahoy.getVisitorId = ahoy.getVisitorToken = function () {
        return visitorId;
    };
    ahoy.reset = function () {
        destroyCookie("ahoy_visit");
        destroyCookie("ahoy_visitor");
        destroyCookie("ahoy_events");
        destroyCookie("ahoy_track");
        return true;
    };
    ahoy.debug = function (enabled) {
        if (enabled === false) {
            destroyCookie("ahoy_debug");
        }
        else {
            setCookie("ahoy_debug", "t", 365 * 24 * 60); // 1 year
        }
        return true;
    };
    ahoy.eventExtra = {};
    ahoy.track = function (name, properties) {
        if (!initialized) {
            return;
        }
        var event = {
            id: generateId(),
            visitId: visitId,
            name: name,
            properties: properties,
            time: new Date().toISOString(),
        };
        for (var key in ahoy.eventExtra) {
            event[key] = ahoy.eventExtra[key];
        }
        log(event);
        eventQueue.push(event);
        saveEventQueue();
        // wait in case navigating to reduce duplicate events
        setTimeout(function () {
            trackEvent(event);
        }, 1000);
    };
    ahoy.trackView = function () {
        var properties = {
            url: window.location.href,
            title: document.title,
            page: page,
        };
        ahoy.track("$view", properties);
    };
    ahoy.trackClicks = function () {
        document.addEventListener("click", (e) => {
            const selectors = "a, button, input[type=submit]";
            let properties;
            if (!(e.target instanceof Element))
                return;
            let target = e.target;
            // Select event target or nearest parent that matches defined selectors.
            if (!target.matches("a, button, input[type=submit]")) {
                const closest = target.closest(selectors);
                if (closest) {
                    target = closest;
                }
                else {
                    // Event does not apply to defined selectors.
                    return;
                }
            }
            properties = eventProperties(target);
            if (target instanceof HTMLInputElement) {
                properties.text = target.value;
            }
            else if (target.textContent) {
                properties.text = target.textContent.trim().replace(/[\s\r\n]+/g, " ");
            }
            if (target instanceof HTMLLinkElement) {
                properties.href = target.href;
            }
            ahoy.track("$click", properties);
        });
    };
    ahoy.trackSubmits = function () {
        document.addEventListener("submit", (e) => {
            if (e.target instanceof HTMLFormElement) {
                const properties = eventProperties(e.target);
                ahoy.track("$submit", properties);
            }
        });
    };
    ahoy.trackChanges = function () {
        document.addEventListener("change", (e) => {
            if (e.target instanceof HTMLElement &&
                e.target.matches("input, textarea, select")) {
                const properties = eventProperties(e.target);
                ahoy.track("$change", properties);
            }
        });
    };
    ahoy.trackAll = function () {
        ahoy.trackView();
        ahoy.trackClicks();
        ahoy.trackSubmits();
        ahoy.trackChanges();
    };
    window.ahoy = ahoy;
})(window);
